// ** Routes Imports
import Page404 from 'pages/PageError/Page404';
import blockRoute from './router/block.route';
import brandRoute from './router/brand.route';
import businessRoutes from './router/business.route';
import clusterRoute from './router/cluster.route';
import commissionRoute from './router/commission';
import contractRoute from './router/contract.route';
import contractTypeRoute from './router/contractType.route';
import couponRoute from './router/coupon.route';
import customerCareRoute from './router/customerCare.route';
import customerCaseTypeRoute from './router/customerCareType.route';
import customerKindRoute from './router/customerKind.route';
import customerLeadRoute from './router/customerLead.route';
import customerType from './router/customerType.route';
import debitRoute from './router/debit.route';
import equipmentGroupRoute from './router/equipmentGroup.route';
import executiveCommandCenterRoute from './router/executiveCommandCenter.route';
import expendType from './router/expendType.route';
import functionGroupRoute from './router/functionGroup.route';
import functionsRoute from './router/functions.route';
import menuRoute from './router/menu.route';
import ordersRoute from './router/orders.route';
import orderStatusRoute from './router/orderStatus.route';
import orderTypeRoute from './router/orderType';
import outputTypeRoute from './router/outputType.route';
import partnerRoute from './router/partner.route';
import permissionRoute from './router/permission.route';
import priceReviewLevelRoute from './router/priceReviewLevel.route';
import pricesRoute from './router/prices.route';
import productRoute from './router/product';
import productAttributeRoute from './router/productAttribute.route';
import productCategoryRoute from './router/productCategory.route';
import productModelRoute from './router/productModel';
import receivePaymentSlipCash from './router/receivePaymentSlipCash.route';
import receivePaymentSlipCredit from './router/receivePaymentSlipCredit.route';
import ReceiveType from './router/ReceiveType.route';
import sourceRoute from './router/source.route';
import stocksRoute from './router/stocks.route';
import stocksDetailRoute from './router/stocksDetail.route';
import stocksInRequestRoute from './router/stocksInRequest.route';
import stocksInTypeRoute from './router/stocksInType.route';
import stocksOutRequestRoute from './router/stocksOutRequest.route';
import stocksOutTypeRoute from './router/stocksOutType.route';
import stocksTakeRequestRoute from './router/stocksTakeRequest.route';
import stocksTakeTypeRoute from './router/stocksTakeType.route';
import stocksTransferRoute from './router/stocksTransfer.route';
import stocksTypeRoute from './router/stocksType.route';
import storeRoute from './router/store.route';
import storeTypeRoute from './router/storeType.route';
import supplierRoute from './router/supplier.route';
import shareholderRelationshipCategory from './router/shareholderRelationshipCategory.route';
import shareholderRelationshipNews from './router/shareholderRelationshipNews.route';
import taskRoute from './router/task.route';
import taskTypeRoute from './router/taskType.route';
import taskWorkFlowRoute from './router/taskWorkFlow.route';
import transferShiftTypeRoute from './router/transferShiftType.route';
import unitRoute from './router/unit';
import userRoute from './router/user.route';
import websiteDirectory from './router/websiteDirectory.route';
import workScheduleTypeRoute from './router/workScheduleType.route';
import yhctScheduleRoute from './router/yhctSchedule.route';

import appointments from './router/appointments.route';
import accountingAccountRoute from './router/accountingAccount.route';
import accountingPeriodRoute from './router/accountingPeriod.route';
import announceRoute from './router/announce.route';
import announceTypeRoute from './router/announeType.route';
import assignTask from './router/assignTask.route';
import assignTaskTypeRoutes from './router/assignTaskTypeCategory.route';
import assignTaskPriorityRoutes from './router/assignTaskPriorityCategory.route';
import assignTaskStatusRoutes from './router/assignTaskStatusCategory.route';
import assignTaskStepRoutes from './router/assignTaskStepCategory.route';
import areaRoute from './router/area.route';
import bankRoute from './router/bank.route';
import bankUserRoute from './router/bankUser.route';
import borrowRequestRoute from './router/borrowRequest.route';
import borrowRequestTypeRoute from './router/borrowRequestType.route';
import budBudgetTypeRoutes from './router/budget-type.route';
import budgetRoute from './router/budget.route';
import budgetPlanRoutes from './router/budgetPlan.route';
import businessTypeRoute from './router/businessType.route';
import businessUserRoute from './router/businessUser.route';
import cashFlowRoute from './router/cashFlow.route';
import companyRoute from './router/company.route';
import companyTypeRoute from './router/companyType.route';
import compareBudget from './router/compareBudget.route';
import costTypeRoute from './router/costType.route';
import cumulatePointTypeRoute from './router/cumulatePointType.route';
import customerRoute from './router/customer.route';
import customerCouponRoute from './router/customerCoupon.route';
import customerDepositRoute from './router/customerDeposit.route';
import customerSubscriberReportRoute from './router/customerSubscriberReport.route';
import customerWorkingRoute from './router/customerWorking.route';
import dashboardRoute from './router/dashboard.route';
import dateCofirmTimeKeepingRoute from './router/dateConfirmTimeKeeping';
import defaultAccount from './router/defaultAccount.route';
import degreeRoute from './router/degree.route';
import denominationRoutes from './router/denomination.route';
import departmentRoute from './router/department.route';
import discountProgramRoute from './router/discountProgram.route';
import discountProgramProduct from './router/discountProgramProduct.route';
import documentTypeRoute from './router/documentType.route';
import emailMarketingRoute from './router/emailMarketing.route';
import exchangePointRoute from './router/exchangePoint.route';
import experienceRoute from './router/experience.route';
import expertiseRoute from './router/expertise.route';
import fileManagerRoute from './router/fileManager.route';
import godOfImport from './router/godOfImport.route';
import holidayRoute from './router/holiday.route';
import hrSalaryRoute from './router/hrSalary.route';
import installmentFormRoute from './router/installmentForm.route';
import installmentPartnerRoute from './router/installmentPartner.route';
import interestContentRoute from './router/interestContent.route';
import invoiceManagementRoute from './router/invoiceManagement.route';
import itemRoute from './router/item.route';
import ledgerRoute from './router/ledger.route';
import leadStatusRoute from './router/leadStatus.route';
import orderInvoiceManagementRoute from './router/orderInvoiceManagement.route';
import pharmacyConfigurationRoute from './router/pharmacyConfiguration.route';
import pharmacySaleManagementRoute from './router/pharmacySaleManagement.route';
import pharmacyReportRoute from './router/pharmacyReport.route';
import { default as lockshiftClose, default as lockshiftCloseRoute } from './router/lockshiftClose.route';
import lockshiftOpen from './router/lockShiftOpen.route';
import lockShiftReportRoutes from './router/lockShiftReport.route';
import mailRoute from './router/mail.route';
import manufacturerRoute from './router/manufacturer.route';
import materialRoutes from './router/material.route';
import materialGroupRoutes from './router/materialGroup.route';
import newsRoutes from './router/news.route';
import newsInsideRoutes from './router/newsInside.route';
import OffWorkManagementRoutes from './router/offwork-management.route';
import offWorkRoute from './router/offWork.route';
import offWorkReviewLevelRoute from './router/offWorkReviewLevel.route';
import offWorkTypeRoute from './router/offWorkType.route';
import originRoute from './router/origin.route';
import organizationChartRoute from './router/organizationChart.route';
import payDebitRoute from './router/payDebit.route';
import paymentFormRoute from './router/paymentForm.route';
import payPartnerRoute from './router/payPartner.route';
import payrollTemplateRoute from './router/payrollTemplate.route';
import pageSettingRoute from './router/pageSetting.route';
import positionRoute from './router/position.route';
import positionLevelRoute from './router/positionLevel.route';
import preOrderRoute from './router/preOrder.route';
import profitLossRoute from './router/profitLoss.route';
import promotionOffersRoute from './router/promotionOffers.route';
import promotionRoute from './router/promotions.route';
import proposalRoute from './router/proposal.route';
import PurchaseCostRoutes from './router/purchaseCost.route';
import purchaseOrderDivisionRoute from './router/purchaseOrderDivision.route';
import purchaseOrderStatusRoute from './router/purchaseOrderStatus.route';
import purchaseOrdersRoutes from './router/purchaseOrders.route';
import purchaseReportRoute from './router/purchaseReport.route';
import purchaseRequisitionRoute from './router/purchaseRequisition.route';
import purchaseRequisitionTypeOptionRoute from './router/purchaseRequisitionTypeOption.route';
import purchaseRequisitionTypeRoute from './router/purchaseRequisitionType.route';
import recruitmentBenefitsCategoryRoutes from './router/recruitmentCategory.route';
import recruitmentBenefitsNewsRoutes from './router/recruitmentNews.route';
import regimeRoute from './router/regime.route';
import regimeTypeRoute from './router/regimeType.route';
import relationshipRoute from './router/relationship.route';
import requestPoRlRoute from './router/requestPoRl.route';
import requestPurchaseOrderRoute from './router/requestPurchaseOrder.route';
import requestUsingBudgetRoute from './router/requestUsingBudget.route';
import returnConditionRoute from './router/return-condition.route';
import returnPolicyRoute from './router/return-policy.route';
import reviewRoute from './router/reviewList.route';
import SellerStore from './router/seller-store-connect.route';
import shiftRoute from './router/shift.route';
import shortLinkRoute from './router/shortLink.route';
import skillRoute from './router/skill.route';
import skillGroupRoute from './router/skillGroup.route';
import skillLevelRoute from './router/skillLevel.route';
import sourseRoute from './router/source.route';
import stocksReviewLevelRoute from './router/stocksReviewLevel.route';
import stocksTransferTypeRoutes from './router/stocksTransferType.route';
import timeKeepingClaimTypeRoute from './router/time-keeping-claim-type.route';
import timeKeepingClaimRoute from './router/time-keeping-claim.route';
import timeKeepingRoute from './router/timeKeeping.route';
import transferShiftRoute from './router/transferShift.route';
import usedPhoneMasterDataRoute from './router/usedPhoneMasterData.route';
import usedPhoneSalePriceRoute from './router/usedPhoneSalePrice.route';
import userGroupsRoute from './router/userGroups.route';
import userLevelHistoryRoute from './router/userLevelHistory.route';
import useScheduleRoute from './router/userSchedule.route';
import vatRoute from './router/vat.route';
import cdrsRoute from './router/voip.route';
import workSchedule from './router/workSchedule';
import zaloTemplateRoute from './router/zaloTemplate.route';

import appConfigRoute from './router/appConfig.route';
import bookingRoute from './router/booking.route';
import careServiceRoute from './router/careService.route';
import customrerOfTaskRoute from './router/customrerOfTask.route';
import groupServiceRoute from './router/groupService.route';
import internalTransfer from './router/internal-transfer';
import internalTransferTypeRoute from './router/internalTransferType.route';
import otherVoucherRoute from './router/otherVoucher.route';
import receiveDebitRoute from './router/receiveDebit.route';
import receivePayRoute from './router/receivePay.route';
import FunctionGroupRoutes from './router/reconcileDebt.route';
import reportRoute from './router/report.route';
import returnPurchaseRoute from './router/returnPurchase.route';
import FunctionGroupRoutesRevertDebt from './router/revertReconcileDebt.route';
import SalaryRoute from './router/salary.route';
import saleChannelRoutes from './router/saleChanelFacebook.route';
import ScriptRoute from './router/script.route';
import StaffCRMRoute from './router/staffCRM.route';
import CustomerReportRoute from './router/customerReport.route';
import CustomerContactRoute from './router/customerContact.route';
import faceProfileRoute from './router/faceProfile.route';
import staticContentRoute from './router/staticContent.route';
import VoipReportRoute from './router/voipReport.route';
import CampaignType from './router/campaignType.route';
import Campaign from './router/campaign.route';
import TaskAllocation from './router/taskAllocation';
import Marketing from './router/marketing.route';
import Quote from './router/quote.route';
import FakeOrderRoute from './router/fakeOrder.route';
import MenuFood from './router/menuFood.route';
import MenuConfigRoute from './router/menuConfig.route';
import ProjectRoute from './router/project.route';
import BannerRoute from './router/banner.route';
import NewsCategoryRoute from './router/newsCategory.route';
import webSiteMenuRoute from './router/websiteMenu.route';
import landingPageRoute from './router/landingPage.route';
import galleryRoute from './router/gallery.route';
import hisConnectionRoute from './router/hisConnection.route';
import videoGallery from './router/videoGallery.route';
import doctorCalendar from './router/doctorCalendar.route';
import recruitmentRoute from './router/recruitment.route';
import recruitmentApplyRoute from './router/recruitmentApply.route';
import EducationLevelRoute from './router/educationLevel.route';
import TestimonialRoute from './router/testimonial.route';
import WhyChoseUsRoute from './router/whyChoseUs.route';
import appOrderDealStatusRoute from './router/appOrderDealStatus.route';
import paymentResultRoute from './router/paymentResult.route';

const otherPages = [
  {
    path: '/404',
    exact: true,
    name: 'Trang không tồn tại',
    component: Page404,
  },
];

const routes = [
  ...blockRoute,
  ...brandRoute,
  ...businessRoutes,
  ...clusterRoute,
  ...commissionRoute,
  ...contractRoute,
  ...contractTypeRoute,
  ...couponRoute,
  ...customerLeadRoute,
  ...leadStatusRoute,
  ...debitRoute,
  ...expendType,
  ...functionGroupRoute,
  ...functionsRoute,
  ...menuRoute,
  ...reviewRoute,
  ...ordersRoute,
  ...orderStatusRoute,
  ...orderTypeRoute,
  ...otherPages,
  ...outputTypeRoute,
  ...partnerRoute,
  ...pageSettingRoute,
  ...priceReviewLevelRoute,
  ...pricesRoute,
  ...productAttributeRoute,
  ...productCategoryRoute,
  ...productModelRoute,
  ...productRoute,
  ...receivePaymentSlipCash,
  ...receivePaymentSlipCredit,
  ...ReceiveType,
  ...sourceRoute,
  ...stocksDetailRoute,
  ...stocksInRequestRoute,
  ...usedPhoneMasterDataRoute,
  ...usedPhoneSalePriceRoute,
  ...stocksInTypeRoute,
  ...stocksOutRequestRoute,
  ...stocksOutTypeRoute,
  ...stocksReviewLevelRoute,
  ...stocksRoute,
  ...stocksTakeTypeRoute,
  ...stocksTransferRoute,
  ...stocksTypeRoute,
  ...storeRoute,
  ...storeTypeRoute,
  ...supplierRoute,
  ...taskWorkFlowRoute,
  ...unitRoute,
  ...taskTypeRoute,
  ...assignTask,
  ...assignTaskTypeRoutes,
  ...assignTaskPriorityRoutes,
  ...assignTaskStatusRoutes,
  ...assignTaskStepRoutes,
  ...customerCareRoute,
  ...customerCaseTypeRoute,
  ...customerKindRoute,
  ...customerType,
  ...taskRoute,
  ...permissionRoute,
  ...userRoute,
  ...costTypeRoute,
  ...experienceRoute,
  ...expertiseRoute,
  ...returnConditionRoute,
  ...customerRoute,
  ...areaRoute,
  ...businessUserRoute,
  ...degreeRoute,
  ...holidayRoute,
  ...hrSalaryRoute,
  ...offWorkRoute,
  ...offWorkReviewLevelRoute,
  ...offWorkTypeRoute,
  ...positionRoute,
  ...shiftRoute,
  ...shareholderRelationshipCategory,
  ...shareholderRelationshipNews,
  ...skillGroupRoute,
  ...skillLevelRoute,
  ...sourseRoute,
  ...timeKeepingRoute,
  ...userGroupsRoute,
  ...userLevelHistoryRoute,
  ...useScheduleRoute,
  ...dateCofirmTimeKeepingRoute,
  ...departmentRoute,
  ...businessTypeRoute,
  ...lockshiftCloseRoute,
  ...budgetRoute,
  ...itemRoute,
  ...accountingAccountRoute,
  ...budBudgetTypeRoutes,
  ...budgetPlanRoutes,
  ...mailRoute,
  ...cashFlowRoute,
  ...requestUsingBudgetRoute,
  ...dashboardRoute,
  ...equipmentGroupRoute,
  ...denominationRoutes,
  ...bankUserRoute,
  ...lockShiftReportRoutes,
  ...executiveCommandCenterRoute,
  ...yhctScheduleRoute,

  ...appointments,
  ...lockshiftOpen,
  ...lockshiftClose,
  ...transferShiftRoute,
  ...skillRoute,
  ...newsRoutes,
  ...newsInsideRoutes,
  ...announceRoute,
  ...transferShiftTypeRoute,
  ...paymentFormRoute,
  ...accountingPeriodRoute,
  ...bankRoute,
  ...materialRoutes,
  ...workScheduleTypeRoute,
  ...regimeRoute,
  ...ledgerRoute,
  ...materialGroupRoutes,
  ...promotionOffersRoute,
  ...promotionRoute,
  ...defaultAccount,
  ...regimeTypeRoute,
  ...fileManagerRoute,
  ...proposalRoute,
  ...customerWorkingRoute,
  ...workSchedule,
  ...borrowRequestTypeRoute,
  ...borrowRequestRoute,
  ...discountProgramRoute,
  ...companyRoute,
  ...requestPoRlRoute,
  ...companyTypeRoute,
  ...purchaseRequisitionRoute,
  ...requestPurchaseOrderRoute,
  ...purchaseOrdersRoutes,
  ...purchaseOrderStatusRoute,
  ...purchaseOrderDivisionRoute,
  ...vatRoute,
  ...announceTypeRoute,
  ...compareBudget,
  ...positionLevelRoute,
  ...exchangePointRoute,
  ...manufacturerRoute,
  ...emailMarketingRoute,
  ...payPartnerRoute,
  ...cumulatePointTypeRoute,
  ...profitLossRoute,
  ...cdrsRoute,
  ...stocksTransferTypeRoutes,
  ...stocksTakeRequestRoute,
  ...returnPolicyRoute,
  ...discountProgramProduct,
  ...relationshipRoute,
  ...SellerStore,
  ...zaloTemplateRoute,
  ...originRoute,
  ...organizationChartRoute,
  ...installmentFormRoute,
  ...installmentPartnerRoute,
  ...preOrderRoute,
  ...customerCouponRoute,
  ...OffWorkManagementRoutes,
  ...payrollTemplateRoute,
  ...PurchaseCostRoutes,
  ...purchaseReportRoute,
  ...shortLinkRoute,
  ...purchaseRequisitionTypeRoute,
  ...purchaseRequisitionTypeOptionRoute,
  ...customerSubscriberReportRoute,
  ...customerDepositRoute,
  ...payDebitRoute,
  ...interestContentRoute,
  ...invoiceManagementRoute,
  ...orderInvoiceManagementRoute,
  ...pharmacyConfigurationRoute,
  ...pharmacySaleManagementRoute,
  ...pharmacyReportRoute,
  ...timeKeepingClaimTypeRoute,
  ...timeKeepingClaimRoute,
  ...godOfImport,
  ...documentTypeRoute,
  ...saleChannelRoutes,
  ...internalTransfer,
  ...internalTransferTypeRoute,
  ...otherVoucherRoute,
  ...receiveDebitRoute,
  ...receivePayRoute,
  ...VoipReportRoute,
  ...appConfigRoute,
  ...customrerOfTaskRoute,
  ...returnPurchaseRoute,
  ...groupServiceRoute,
  ...careServiceRoute,
  ...websiteDirectory,
  ...bookingRoute,
  ...staticContentRoute,
  ...FunctionGroupRoutes,
  ...FunctionGroupRoutesRevertDebt,
  ...reportRoute,
  ...StaffCRMRoute,
  ...CampaignType,
  ...Campaign,
  ...TaskAllocation,
  ...CustomerReportRoute,
  ...CustomerContactRoute,
  ...faceProfileRoute,
  ...SalaryRoute,
  ...ScriptRoute,
  ...Marketing,
  ...Quote,
  ...FakeOrderRoute,
  ...MenuFood,
  ...MenuConfigRoute,
  ...ProjectRoute,
  ...BannerRoute,
  ...NewsCategoryRoute,
  ...webSiteMenuRoute,
  ...landingPageRoute,
  ...galleryRoute,
  ...hisConnectionRoute,
  ...videoGallery,
  ...doctorCalendar,
  ...recruitmentRoute,
  ...recruitmentBenefitsCategoryRoutes,
  ...recruitmentBenefitsNewsRoutes,
  ...recruitmentApplyRoute,
  ...EducationLevelRoute,
  ...TestimonialRoute,
  ...WhyChoseUsRoute,
  ...appOrderDealStatusRoute,
  ...paymentResultRoute,

  ...assignTask,
];

export default routes;
